import { PencilSquareIcon } from '@heroicons/react/24/outline';
import React, { useMemo, useState } from 'react';
import { useListOrderTagsQuery } from '../../../API/order/tags/OrderTagApi';
import { TagBadge } from '../../../tailwindComponents/badgeTW/TagBadge';
import { TextButtonTW } from '../../../tailwindComponents/buttonTW/TextButtonTW';
import { SlideOver } from '../../../tailwindComponents/slideOver/SlideOver';
import { Show } from '../../shared/Show';
import { AssociateTagContainer } from './AssociateTagContainer';
import { ListContainer } from './listing/ListContainer';
import { SpinnerTW } from '../../../tailwindComponents/spinnerTW/SpinnerTW';
import { sortTagsAlphabeticallyByType } from '../../../utilities/order/tags/sortTagsAlphabeticallyByType';

export interface IOrderTagsContainerProps {
  orderId: string;
}

export const OrderTagsContainer: React.FC<IOrderTagsContainerProps> = ({ orderId }) => {
  const { data: tags = [], isFetching: isTagsFetching } = useListOrderTagsQuery(orderId);
  const [editTags, setEditTags] = useState<boolean>(false);

  const sortedTags = useMemo(() => {
    return [...tags].sort(sortTagsAlphabeticallyByType);
  }, [tags]);

  return (
    <>
      <Show when={!isTagsFetching} fallback={<SpinnerTW />}>
        <div className={'flex gap-2'}>
          <TagButton setEditTags={setEditTags} />
          <div className={'flex-wrap space-x-2'}>
            {sortedTags.map((orderTag) => (
              <div key={orderTag.tag.id} className={'float-left'}>
                <TagBadge orderTag={orderTag} />
              </div>
            ))}
          </div>
        </div>
      </Show>
      <SlideOver
        open={editTags}
        setOpen={setEditTags}
        title={'Edit Tags'}
        description={
          'Tags are an easy way to add special data to an order for informational, tracking, and reporting purposes.'
        }
      >
        <AssociateTagContainer orderId={orderId} setEditTags={setEditTags} />
        <ListContainer orderId={orderId} />
      </SlideOver>
    </>
  );
};

const TagButton: React.FC<{ setEditTags: React.Dispatch<React.SetStateAction<boolean>> }> = ({ setEditTags }) => (
  <TextButtonTW className={'flex items-center'} onClick={() => setEditTags(true)}>
    <PencilSquareIcon className={'h-4 w-4 flex-none'} />
    <p>Tags:</p>
  </TextButtonTW>
);
